import React from 'react'

import FormElementInput from "../../../gd-form/form-element/input/input"

type Props = {
    url: string
}

export default function ShareLinkCopy(props:Props) {

    const onClickCopy = () => {
        gd.utils.copyToClipboard(props.url);
        gd.growl.success("Url copied to clipboard")
    }

    return (
        <div className="share-link-copy">
            <FormElementInput size="small" value={props.url}/>
            <div className="copy-button ui5-link-small" onClick={onClickCopy}>Copy Link</div>
        </div>
    )
}